<template>
  <proofreading-select-manuscript slot="main" :novel-id="novelId" />
</template>

<script lang="ts">
import Vue from "vue";
import ProofreadingSelectManuscript from "@/components/organisms/proofreading/ProofreadingSelectManuscript.vue";

export default Vue.extend({
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { ProofreadingSelectManuscript },
  props: {
    novelId: String,
  },
});
</script>
